import { useAppContext } from '../../context/AppContext';
import { LandingTrans } from '../../utils/translations';

export default function SafetyCallout() {
  const { language } = useAppContext();
  const t = LandingTrans[language];

  return (
    <div className="mx-6 md:mx-20 -mt-6 relative bg-brown rounded overflow-hidden">
      <span className="absolute left-0 top-0 bottom-0 w-1 bg-clay" aria-hidden />
      <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start md:items-center pl-6 md:pl-16 pr-6 md:pr-16 py-10 md:py-12">
        <span className="text-4xl flex-shrink-0" aria-hidden>🛡️</span>
        <div>
          <h3 className="font-serif text-2xl md:text-[26px] font-medium text-white mb-3">
            {t.safetyTitle}
          </h3>
          <p className="text-[15px] font-sans font-light text-white/90 leading-relaxed">
            {t.safetyText}
          </p>
        </div>
      </div>
    </div>
  );
}
